export class PartiteSearchModel {
  tokenCliente?: string;
  daSaldare?: boolean;
  dataDal?:Date;
  dataAl?:Date;
  idIncasso?: number;
}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/models/incassi/partite-search.model.ts